import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { getAccountBySeachApi } from "../../apiservice/setting";
import { getSalesQuatataionInvoiceApi } from "../../apiservice/quotation";
import { createQuotationPayload } from "../../utils/quotation";

// Fetch Quotation Voucher Number
export const fetchQuotationVoucherNumber = createAsyncThunk(
  "quotation/fetchVoucherNumber",
  async (val, { rejectWithValue }) => {
    try {
      const res = await getSalesQuatataionInvoiceApi({ entryDate: val });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Fetch Sales Accounts
export const fetchSalesAccounts = createAsyncThunk(
  "quotation/fetchSalesAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({ multiType: ["sale_account"] });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create / Update Quotation
export const createQuotation = createAsyncThunk(
  "quotation/createQuotation",
  async (
    { location, selectedDiscountAcc, selectedTaxAcc, selectedTransportAcc },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().quotation;
      const authInfo = getState().auth.auth_info;

      const payload = createQuotationPayload({
        state,
        authInfo,
        selectedDiscountAcc,
        selectedTaxAcc,
        selectedTransportAcc,
      });

      let url = `/quotation/create-sales-quotation`;
      if (getState().quotationRecord?.isEditQuotationRecord) {
        url = `/quotation/update-sales-quotation`;
      }

      const res = await postData(url, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
